import TextField from "../../BaseInputFields/TextField/TextField";
import {
  FieldLabeledProps,
  SocialSecurityNumberProps,
} from "../../types/fieldTypes";
import { formatSSN } from "./utils";

export interface SocialSecurityNumberFieldProps
  extends SocialSecurityNumberProps {
  labelProps?: FieldLabeledProps;
  isSensitive?: boolean;
}

/**Inherits Text Field with concrete parameters like placeholder*/
const SocialSecurityNumberField: React.FC<SocialSecurityNumberFieldProps> = (
  props
) => {
  return (
    <TextField
      className={props.className}
      label={props.label}
      description={props.description}
      value={formatSSN(props.value)}
      disabled={props.disabled}
      onSubmit={props.onSubmit}
      errorMessages={props.errorMessages}
      isRequired={props.isRequired}
      placeholder="999-99-9999"
      isSensitive={props.isSensitive ?? true}
      maxLength={11}
      inputMode="numeric"
      sanitize={formatSSN}
      labelProps={props.labelProps}
    />
  );
};

export default SocialSecurityNumberField;
